import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'

export default class InvoiceFileLastDataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id)
  }

  // eslint-disable-next-line no-unused-vars
  callAction(actionName, params) {
    if (actionName == 'getLastInvoice') {
      this.$store.commit('SET_PROCESSING', true)

      GraphqQlApi.callOperation({operationId: 'invoiceFileLast'}).then(response => {
        this.$store.commit('SET_PROCESSING', false)
        let url = response.data.energyAccountQuery.invoiceFileLast.data[0].fileUri
        if (!url.endsWith('file=')) {
          this.openInNewTab(url)
          return
        }
        this.$store.commit('SET_NOTIFY', { text: 'Квитанций не знайдено!' })

      })
    }
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {

  }

  openInNewTab(url) {
    var win = window.open(url, '_blank')
    win.focus()
  }
}